import reducer from "./reducers";

import * as modalOperations from "./operations";
import * as modalTypes from "./types";
import * as modalHooks from "./hooks";

export { modalOperations, modalTypes, modalHooks };

export default reducer;
